import React from 'react';

import SupplierContractsIndex from '../../supplier_contracts/SupplierContractsIndex';
import { useProcurement } from '../context/ProcurementContext';

const ProcurementContractManagementExpenditureContractsTab = () => {
    const { routes, settings } = useProcurement();

    return (
        <SupplierContractsIndex
            updateSignedContractUrl={routes.updateSignedContractUrl}
            departmentsOptions={settings.departmentsOptions}
            ownersOptions={settings.ownersOptions}
            isSupplierPortalEnabled={settings.isSupplierPortalEnabled}
        />
    );
};

export default ProcurementContractManagementExpenditureContractsTab;
